import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=3b95f6bb&scoped=true"
var script = {}
import style0 from "./FooterView.vue?vue&type=style&index=0&id=3b95f6bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95f6bb",
  null
  
)

export default component.exports